export default __webpack_public_path__ + "static/6803-9e6691f128d1b42930679389a5e51968.jpg";